import { render, staticRenderFns } from "./TableRecordComponent.vue?vue&type=template&id=34fc8e0a&"
import script from "./TableRecordComponent.vue?vue&type=script&lang=js&"
export * from "./TableRecordComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports